import TimeProfileOptionViewState from './schema/TimeProfileOptionViewState';
import { createStore } from 'satcheljs';
import '../mutators/setShownViewMutator';
import '../mutators/saveProfilesMutator';
import '../mutators/deleteProfileMutator';
import '../mutators/enableDisableProfileMutator';
import '../mutators/setIsUpdatingProfileUpdateMutator';
import ProfilesRequestStatus from './schema/ProfilesRequestStatus';
import TimeProfileShownView from './schema/TimeProfileShownView';
import initializeProfileEditState from '../utils/initializeProfileEditState';

let initialStore: TimeProfileOptionViewState = {
    profiles: undefined,
    profilesOrder: undefined,
    isSaving: false,
    isPerformingProfileUpdate: false,
    getProfilesRequestStatus: ProfilesRequestStatus.NotInitiated,
    shownView: TimeProfileShownView.Main,
    profileEditState: initializeProfileEditState(),
};

export default createStore<TimeProfileOptionViewState>('timeProfileOptionStore', initialStore);
